<template>
  <div class="pt-6">
    <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
      {{ $t("customers.label.transaction_history") }}
    </div>
    <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
      <vs-tab :label="$t('customers.label.activity_log')">
        <div class="vx-rowmx-1">
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="activityLogList"
            description
            search
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
            class="mx-2 table-height"
          >
            <template slot="header">
              <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
                {{ $t("customers.label.activity_log") }}
              </div>
              <!-- ADD NEW -->
              <ul class="horizontal-sm-btn flex mb-2 order-1">
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="start-date"
                      :placeholder="$t('customers.label.start_date')"
                      v-model="search.fromDate"
                      :format="formattedStartDate"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="end-date"
                      class="end-date-calender"
                      :placeholder="$t('customers.label.end_date')"
                      v-model="search.toDate"
                      :format="formattedEndDate"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      class="mr-sm-3 mt-1"
                      icon="icon-search"
                      @click="getTransactionHistoryOfficeList"
                    ></vs-button>
                  </div>
                </li>
              </ul>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.office_id") }}</vs-th>
              <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
              <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
              <vs-th>{{ $t("customers.label.history") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(history, index) in data">
                <vs-td :data="history.officeId">{{ history.user }}</vs-td>

                <vs-td :data="getDate(history.transactionDate)">{{
                  getDate(history.transactionDate)
                }}</vs-td>
                <vs-td :data="history.transactionType">{{
                  history.transactionType
                }}</vs-td>
                <vs-td :data="history.history">
                  {{ getHistory(history) }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.recharge')">
        <div class="vx-rowmx-1">
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="sortedRechargeData"
            description
            search
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
            class="mx-2 table-height"
          >
            <template slot="header">
              <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
                {{ $t("customers.label.recharge") }}
              </div>
              <!-- ADD NEW -->
              <ul class="horizontal-sm-btn flex mb-2 order-1">
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="start-date"
                      :placeholder="$t('customers.label.start_date')"
                      v-model="recharge.fromDate"
                      :format="formateDate(recharge.fromDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="end-date"
                      class="end-date-calender"
                      :placeholder="$t('customers.label.end_date')"
                      v-model="recharge.toDate"
                      :format="formateDate(recharge.toDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      class="mr-sm-3 mt-1"
                      icon="icon-search"
                      @click="getRechargeData"
                    ></vs-button>
                  </div>
                </li>
              </ul>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customer.label.generationdatetime") }}</vs-th>
              <vs-th>{{ $t("customers.label.transaction_id") }}</vs-th>
              <vs-th>{{ $t("customers.label.application_transaction_id") }}</vs-th>
              <vs-th>{{ $t("customers.label.application_name") }}</vs-th>
              <vs-th>{{ $t("customers.label.recharge_value") }}</vs-th>
              <vs-th>{{ $t("customers.label.interface") }}</vs-th>
              <vs-th>{{ $t("customers.label.result") }}</vs-th>
              <vs-th>{{ $t("customers.label.comment") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(history, index) in data">
                <vs-td :data="history.generation_time">{{
                  history.generation_time
                }}</vs-td>

                <vs-td :data="history.transaction_id">{{ history.transaction_id }}</vs-td>
                <vs-td :data="history.application_transaction_id">{{
                  history.application_transaction_id
                }}</vs-td>
                <vs-td :data="history.application_name">
                  {{ history.application_name }}
                </vs-td>
                <vs-td :data="history.balDetails[0].recharge_value">
                  {{ history.balDetails[0].recharge_value }}
                </vs-td>
                <vs-td :data="history.interface">
                  {{ history.interface }}
                </vs-td>
                <vs-td :data="history.balDetails[0].result">
                  {{ history.balDetails[0].result }}
                </vs-td>
                <vs-td :data="history.comment">
                  {{ history.comment }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.cdr')">
        <div class="vx-rowmx-1">
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="cdrData"
            description
            search
            :description-items="descriptionItems"
            @selected="navigateToCdr"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
            class="mx-2 table-height"
          >
            <template slot="header">
              <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
                {{ $t("customers.label.cdr") }}
              </div>
              <!-- ADD NEW -->
              <ul class="horizontal-sm-btn flex mb-2 order-1">
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="start-date"
                      :placeholder="$t('customers.label.start_date')"
                      v-model="cdr.fromDate"
                      :format="formateDate(cdr.fromDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="end-date"
                      class="end-date-calender"
                      :placeholder="$t('customers.label.end_date')"
                      v-model="cdr.toDate"
                      :format="formateDate(cdr.toDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      class="mr-sm-3 mt-1"
                      icon="icon-search"
                      @click="getCdrData"
                    ></vs-button>
                  </div>
                </li>
              </ul>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customer.label.generationdatetime") }}</vs-th>
              <vs-th>{{ $t("customers.label.transaction_id") }}</vs-th>
              <vs-th>{{ $t("customers.label.charge_party") }}</vs-th>
              <vs-th>{{ $t("customers.label.service_subs_type") }}</vs-th>
              <vs-th>{{ $t("customers.label.calling_party") }}</vs-th>
              <vs-th>{{ $t("customers.label.called_party") }}</vs-th>
              <vs-th>{{ $t("customers.label.usage") }}</vs-th>
              <vs-th>{{ $t("customers.label.monetary_charge") }}</vs-th>
              <vs-th>{{ $t("customers.label.result_code") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(history, index) in data">
                <vs-td :data="history.generation_time">{{
                  history.generation_time
                }}</vs-td>
                <vs-td :data="history.transaction_id">{{ history.transaction_id }}</vs-td>
                <!-- <vs-td :data="history.application_transaction_id">{{
                  history.application_transaction_id
                }}</vs-td> -->
                <vs-td :data="history.charge_party">
                  {{ history.charge_party }}
                </vs-td>
                <vs-td :data="history.service_subs_type">
                  {{ history.service_subs_type }}
                </vs-td>
                <vs-td :data="history.calling_party">
                  {{ history.calling_party }}
                </vs-td>
                <vs-td :data="history.called_party">
                  {{ history.called_party }}
                </vs-td>
                <vs-td :data="history.usage">
                  {{ history.usage }}
                </vs-td>
                <vs-td :data="history.monetary_charge">
                  {{ calMonetaryCharge(history.monetary_charge) }}
                </vs-td>
                <vs-td :data="history.result_code">
                  {{ history.result_code }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.notifications')">
        <div class="vx-rowmx-1">
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="sortedNotificationData"
            description
            search
            @selected="showMessage"
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
            class="mx-2 table-height"
          >
            <template slot="header">
              <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
                {{ $t("customers.label.notifications") }}
              </div>
              <!-- ADD NEW -->
              <ul class="horizontal-sm-btn flex mb-2 order-1">
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="start-date"
                      :placeholder="$t('customers.label.start_date')"
                      v-model="notification.fromDate"
                      :format="formateDate(notification.fromDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="end-date"
                      class="end-date-calender"
                      :placeholder="$t('customers.label.end_date')"
                      v-model="notification.toDate"
                      :format="formateDate(notification.toDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      class="mr-sm-3 mt-1"
                      icon="icon-search"
                      @click="getNotificationData"
                    ></vs-button>
                  </div>
                </li>
              </ul>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customer.label.generationdatetime") }}</vs-th>
              <vs-th>{{ $t("customers.label.transaction_id") }}</vs-th>
              <vs-th>{{ $t("customers.label.origination") }}</vs-th>
              <vs-th>{{ $t("customers.label.communication_type") }}</vs-th>
              <vs-th>{{ $t("customers.label.destination_address") }}</vs-th>
              <vs-th>{{ $t("customers.label.event") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(history, index) in data" :data="history">
                <vs-td :data="history.generation_time">{{
                  history.generation_time
                }}</vs-td>

                <vs-td :data="history.transaction_id">{{ history.transaction_id }}</vs-td>
                <vs-td :data="history.origination_address">{{
                  history.origination_address
                }}</vs-td>
                <vs-td :data="history.communication_type">
                  {{ history.communication_type }}
                </vs-td>
                <vs-td :data="history.destination_address">
                  {{ history.destination_address }}
                </vs-td>
                <vs-td :data="history.event">
                  {{ history.event }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.slc')">
        <div class="vx-rowmx-1">
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="sortedSlcData"
            description
            search
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
            class="mx-2 table-height"
          >
            <template slot="header">
              <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
                {{ $t("customers.label.slc") }}
              </div>
              <!-- ADD NEW -->
              <ul class="horizontal-sm-btn flex mb-2 order-1">
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="start-date"
                      :placeholder="$t('customers.label.start_date')"
                      v-model="slc.fromDate"
                      :format="formateDate(slc.fromDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="end-date"
                      class="end-date-calender"
                      :placeholder="$t('customers.label.end_date')"
                      v-model="slc.toDate"
                      :format="formateDate(slc.toDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      class="mr-sm-3 mt-1"
                      icon="icon-search"
                      @click="getSlcData"
                    ></vs-button>
                  </div>
                </li>
              </ul>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.state_Change_Time") }}</vs-th>
              <vs-th>{{ $t("customers.label.transaction_id") }}</vs-th>
              <vs-th>{{ $t("customers.label.event") }}</vs-th>
              <vs-th>{{ $t("customers.label.previous_state") }}</vs-th>
              <vs-th>{{ $t("customers.label.current_state") }}</vs-th>
              <!-- <vs-th>{{ $t("customers.label.status") }}</vs-th> -->
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(history, index) in data" :data="history">
                <vs-td :data="history.eventTime">{{ history.eventTime }}</vs-td>

                <vs-td :data="history.transId">{{ history.transId }}</vs-td>
                <vs-td :data="history.slcEventName">{{ history.slcEventName }}</vs-td>
                <vs-td :data="history.previousLifeCycleStateName">
                  {{ history.previousLifeCycleStateName }}
                </vs-td>
                <vs-td :data="history.currentLifeCycleStateName">
                  {{ history.currentLifeCycleStateName }}
                </vs-td>
                <!-- <vs-td :data="history.status">
                  {{ history.status }}
                </vs-td> -->
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.SpendCapHistory')">
        <div class="vx-rowmx-1">
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="sortedSpendCapHistory"
            description
            search
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
            class="mx-2 table-height"
          >
            <template slot="header">
              <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
                {{ $t("customers.label.SpendCapHistory") }}
              </div>
              <!-- ADD NEW -->
              <ul class="horizontal-sm-btn flex mb-2 order-1">
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="start-date"
                      :placeholder="$t('customers.label.start_date')"
                      v-model="spend.fromDate"
                      :format="formateDate(spend.fromDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="end-date"
                      class="end-date-calender"
                      :placeholder="$t('customers.label.end_date')"
                      v-model="spend.toDate"
                      :format="formateDate(spend.toDate)"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      class="mr-sm-3 mt-1"
                      icon="icon-search"
                      @click="getSpendData"
                    ></vs-button>
                  </div>
                </li>
              </ul>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.DateTime") }}</vs-th>
              <vs-th>{{ $t("customers.label.transaction_id") }}</vs-th>
              <vs-th>{{ $t("customers.label.SpendCapEventName") }}</vs-th>
              <vs-th>{{ $t("customers.label.SpendingLimit") }}</vs-th>
              <vs-th>{{ $t("customers.label.ConsumedLimit") }}</vs-th>
              <vs-th>{{ $t("customers.label.EventId") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(history, index) in data" :data="history">
                <vs-td :data="history.genTime">{{ history.genTime }}</vs-td>
                <vs-td :data="history.transId">{{ history.transId }}</vs-td>
                <vs-td :data="history.spendCapEventName">{{
                  history.spendCapEventName
                }}</vs-td>
                <vs-td :data="history.spendingLimit">
                  {{ history.spendingLimit }}
                </vs-td>
                <vs-td :data="history.consumedLimit">
                  {{ history.consumedLimit }}
                </vs-td>
                <vs-td :data="history.spendCapEventId">
                  {{ history.spendCapEventId }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.external_activity_log')">
        <div class="vx-rowmx-1">
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="ExternalActivityLogList"
            description
            search
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
            class="mx-2 table-height"
          >
            <template slot="header">
              <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
                {{ $t("customers.label.external_activity_log") }}
              </div>
              <!-- ADD NEW -->
              <ul class="horizontal-sm-btn flex mb-2 order-1">
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="start-date"
                      :placeholder="$t('customers.label.start_date')"
                      v-model="search.fromDate"
                      :format="formattedStartDate"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 mt-1 cursor-pointer flex items-center text-lg font-medium w-full date-field"
                  >
                    <datepicker
                      name="end-date"
                      class="end-date-calender"
                      :placeholder="$t('customers.label.end_date')"
                      v-model="search.toDate"
                      :format="formattedEndDate"
                    ></datepicker>
                  </div>
                </li>
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      class="mr-sm-3 mt-1"
                      icon="icon-search"
                      @click="getExternalTransactionHistoryList"
                    ></vs-button>
                  </div>
                </li>
              </ul>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
              <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
              <vs-th>{{ $t("customers.label.history") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(history, index) in data">
                <vs-td :data="getDate(history.transactionDate)">{{
                  getDate(history.transactionDate)
                }}</vs-td>
                <vs-td :data="history.transactionType">{{
                  history.transactionType
                }}</vs-td>
                <vs-td :data="history.history">
                  {{ history.history }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('admin.label.MessageLog')">
        <div class="vx-row">
          <vx-card>
            <vs-table
              max-items="5"
              search
              pagination
              :description="false"
              :data="clientMessageLogList || []"
            >
              <template slot="header">
                <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
                  {{ $t("admin.label.MessageLog") }}
                </div>
              </template>
              <template slot="thead">
                <vs-th>{{ $t("admin.label.MessageTo") }}</vs-th>
                <vs-th>{{ $t("admin.label.MessageFrom") }}</vs-th>
                <vs-th>{{ $t("admin.label.Subject") }}</vs-th>
                <vs-th>{{ $t("admin.label.MessageType") }}</vs-th>
                <vs-th>{{ $t("admin.label.Template") }}</vs-th>
                <vs-th>{{ $t("admin.label.status") }}</vs-th>
                <vs-th class="tHeadCenter">
                  {{ $t("admin.label.Actions") }}
                </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="clientMessageLogList"
                  v-for="(message, index) in data"
                >
                  <vs-td>{{ message.messageTo }}</vs-td>
                  <vs-td>{{ message.messageFrom }}</vs-td>
                  <vs-td>{{ message.subject }}</vs-td>
                  <vs-td>{{ message.messageType }}</vs-td>
                  <vs-td>{{ message.template }}</vs-td>
                  <vs-td>{{ message.status }}</vs-td>
                  <vs-td>
                    <div class="text-center">
                      <feather-icon
                        title="Command"
                        icon="EyeIcon"
                        @click="openPopup(message.body)"
                        class="text-primary icon_row"
                        svgClasses="w-5 h-5 stroke-current text-primary"
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-popup
              :title="$t('admin.label.ViewMessageLog')"
              :active.sync="messageLogPopup"
              class="popup-close"
            >
              <div
                v-if="parsedData"
                class="vx-row"
                v-for="(value, key) in parsedData"
                :key="key"
              >
                <div class="vx-col w-1/2 font-bold">{{ stripTags(key) }}:</div>
                <div class="vx-col w-1/2">
                  {{ value }}
                </div>
              </div>
            </vs-popup>
          </vx-card>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.notes')">
        <div>
          <div
            style="
              margin-right: auto;
              font-size: 1.5rem;
              font-weight: 550;
              margin-top: 6px;
              margin-bottom: 6px;
            "
          >
            {{ $t("customers.label.notes") }}
          </div>
          <vs-table no-data-text="">
            <template slot="header">
              <vx-card class="mb-base">
                <ValidationObserver ref="observer">
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <small class="date-label"
                        >{{ $t("customers.label.description")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('customers.label.description')"
                        :key="resetKey"
                      >
                        <vs-textarea v-model="note.note"></vs-textarea>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col w-full">
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-plus"
                        class="truncate mt-2 float-right"
                        size="small"
                        @click="addNote"
                        >{{ $t("customers.label.add_note") }}</vs-button
                      >
                    </div>
                    <vs-table
                      :max-items="5"
                      class="w-full"
                      pagination
                      :data="clientNotes"
                    >
                      <template slot="thead">
                        <vs-th>{{ $t("customers.label.id") }}</vs-th>
                        <vs-th>{{ $t("customers.label.created_by") }}</vs-th>
                        <vs-th>{{ $t("customers.label.created_on") }}</vs-th>
                        <vs-th>{{ $t("customers.label.note") }}</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr :key="index" :data="data" v-for="(clientNotes, index) in data">
                          <vs-td :data="clientNotes.id">{{ clientNotes.id }}</vs-td>
                          <vs-td>{{ clientNotes.createdById }}</vs-td>
                          <vs-td :data="getDate(clientNotes.createdOn)">
                            <span>{{ getDate(clientNotes.createdOn) }}</span></vs-td
                          >
                          <vs-td :data="clientNotes.note">{{ clientNotes.note }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </ValidationObserver>
              </vx-card>
            </template>
          </vs-table>
        </div>
      </vs-tab>
    </vs-tabs>

    <vs-popup
      :title="$t('customers.label.filter_by_date')"
      :active.sync="filterPopup"
      class="popup-close"
    >
      <div class="vx-row md:w-1/2 lg:w-1/2 sm:w-full mb-6">
        <small class="date-label">{{ $t("customers.label.start_date") }}</small>
        <datepicker name="start-date" v-model="search.fromDate"></datepicker>
      </div>
      <div class="vx-row md:w-1/2 lg:w-1/2 sm:w-full mb-6">
        <small class="date-label">{{ $t("customers.label.end_date") }}</small>
        <datepicker name="end-date" v-model="search.toDate"></datepicker>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-2/3 w-full">
          <vs-button class="mr-3 mb-2" @click="getTransactionHistoryOfficeList">{{
            $t("customers.label.search")
          }}</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    Datepicker,
    ValidationProvider,
    ValidationObserver,
  },
  props: ["clientId"],
  data() {
    return {
      user_data: null,
      user_not_found: false,
      searchOption: 0,
      note: {
        note: "",
      },
      resetKey: 0,
      activeTab: 0,
      descriptionItems: [5, 10, 15],
      filterPopup: false,
      messageLogPopup: false,
      parsedData: null,
      search: {
        fromDate: moment().startOf("month").format("YYYY-MM-DD"),
        toDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
      recharge: {
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
      cdr: {
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
      slc: {
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
      notification: {
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
      eventTypeCategoryMsg: "",
      spend: {
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
    };
  },
  computed: {
    ...mapState({
      spendData: (state) => state.customerActivityLog.spendData,
      activityLogList: (state) => state.customerActivityLog.activityLogList,
      ExternalActivityLogList: (state) =>
        state.customerActivityLog.externalActivityLogList,
      clientDetail: (state) => state.customer.clientDetail,
      clientDetailData: (state) => state.customer.clientDetailData,
      clientNotes: (state) => state.customerActivityLog.notes,
      rechargeData: (state) => state.customerActivityLog.rechargeData,
      cdrData: (state) => state.customerActivityLog.cdrData,
      notificationData: (state) => state.customerActivityLog.notificationData,
      slcData: (state) => state.customerActivityLog.slcData,
      formattedDate: (state) => state.settings.selectedDateFormat,
      clientMessageLogList: (state) => state.customerActivityLog.clientMessageLogList,
    }),
    formateDate() {
      return (date) => {
        let dateStr = moment(date).format(this.formattedDate);
        let [day, month, year] = dateStr.split("-");
        day = day.toLowerCase();
        year = year.toLowerCase();
        return `${day}-${month}-${year}`;
      };
    },
    formattedStartDate() {
      let dateStr = moment(this.search.fromDate).format(this.formattedDate);
      let [day, month, year] = dateStr.split("-");
      day = day.toLowerCase();
      year = year.toLowerCase();
      return `${day}-${month}-${year}`;
    },
    sortedNotificationData() {
      return [...this.notificationData].sort((a, b) => {
        return new Date(b.generation_time) - new Date(a.generation_time);
      });
    },
    sortedSpendCapHistory() {
      return [...this.spendData].sort((a, b) => {
        return new Date(b.genTime) - new Date(a.genTime);
      });
    },
    sortedRechargeData() {
      return [...this.rechargeData].sort((a, b) => {
        return new Date(b.generation_time) - new Date(a.generation_time);
      });
    },
    sortedSlcData() {
      return [...this.slcData].sort((a, b) => {
        return new Date(b.eventTime) - new Date(a.eventTime);
      });
    },
    formattedEndDate() {
      let dateStr = moment(this.search.toDate).format(this.formattedDate);
      let [day, month, year] = dateStr.split("-");
      day = day.toLowerCase();
      year = year.toLowerCase();
      return `${day}-${month}-${year}`;
    },
  },
  methods: {
    getOrderStatusColor(status) {
      if (status == "closed") return "danger";
      if (status == "inactive") return "success";
      return "primary";
    },
    navigateToCdr() {
      this.$router.push({
        name: "CDRDetail",
        params: {
          id: this.clientId,
        },
        query: {
          id: this.clientId,
        },
      });
    },
    calMonetaryCharge(num) {
      const numericValue = parseFloat(num.replace(/[^\d.]/g, "")) / 100;
      return Number.isInteger(numericValue)
        ? `${numericValue} EUR` // No decimals if it's a whole number
        : `${numericValue.toFixed(2)} EUR`; // Keep 2 decimals if needed
    },
    async getTransactionHistoryOfficeList() {
      try {
        await this.$store.dispatch("customerActivityLog/getActivityLogList", {
          id: this.clientId,
          fromDate: moment(this.search.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.search.toDate).format("YYYY-MM-DD"),
        });

        if (this.filterPopup) this.filterPopup = false;
      } catch (e) {
        console.log(
          "something went to wrong while retrieving transaction history office:",
          e
        );
      }
    },
    async getExternalTransactionHistoryList() {
      try {
        await this.$store.dispatch(
          "customerActivityLog/getExternalActivityLogListAction",
          {
            id: this.clientId,
            fromDate: moment(this.search.fromDate).format("YYYY-MM-DD"),
            toDate: moment(this.search.toDate).format("YYYY-MM-DD"),
          }
        );
      } catch (e) {
        console.log(
          "something went to wrong while retrieving transaction history office:",
          e
        );
      }
    },
    async getNotes() {
      try {
        await this.$store.dispatch(
          "customerActivityLog/getClientNotesAction",
          this.$route.params.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addNote() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        const data = {
          id: this.$route.params.id,
          note: this.note,
        };
        await this.$store.dispatch("customerActivityLog/addClientNotesAction", data);
        this.getNotes();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Note Added Successfully!",
          type: "success",
        });
        this.resetKey++;
        this.note.note = "";
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    getDate(date) {
      const timeFormat = "hh:mm a";
      const combinedFormat = `${this.formattedDate} ${timeFormat}`;
      return moment(date).format(combinedFormat);
    },
    getHistory(activity) {
      let obj = JSON.parse(activity.history);
      let serialNumber = "";
      let planDetails = [];
      let clientServiceData = [];
      let serviceId = 0;
      if (obj.clientServiceData) {
        clientServiceData = obj.clientServiceData;
        serviceId = clientServiceData[0].serviceId;
      }
      if (obj.serialNumber) {
        let serialNum = obj.serialNumber;
        serialNumber = serialNum[0].serialNumber;
      }
      if (obj.plans && obj.plans.length) {
        const planslist = obj.plans;
        planDetails = planslist[0];
      }

      const eventTypeCategoryMsg = {
        //client related data
        "CREATE CLIENT": "Client Created Successfully with Name: " + obj.userName,
        "UPDATE CLIENT": "Update Successfully: " + obj.officeTransfer,
        "UPDATE ADDRESS": "Client Address Updated successfully with ",
        "DELETE CLIENT":
          "Client Closed successfully with ReasonId " + obj.closureReasonId,

        //add plan data
        "CREATE MULTIPLEORDERS":
          "PlanCode : " +
          "(" +
          planDetails.planCode +
          ")" +
          "   " +
          "PlanDescription : " +
          "(" +
          planDetails.planDescription +
          ")",

        //order related data
        "CREATE ORDER":
          "PlanCode :" + obj.planCode + " Contract Period :" + obj.contractPeriod,
        "CHANGEPLAN ORDER":
          "PlanCode : " +
          obj.planCode +
          " , " +
          " ChangedPlan : " +
          obj.changePlanDetail +
          " , " +
          "  Contract Period : " +
          obj.contractPeriod,
        "DELETE ORDER": "Order Deleted successfully",
        "EXTENSION ORDER":
          "Order Extended to " + obj.extensionPeriod + " Due To " + obj.extensionReason,
        "RECONNECT ORDER":
          "Order Re-Connected successfully with OrderId : " + obj.resourceId,
        "REACTIVE ORDER":
          "Order Re-Activated successfully with OrderId : " + obj.resourceId,
        "SUSPEND ORDER":
          "Order Suspended with reason " +
          obj.suspensionReason +
          " and Description " +
          obj.suspensionDescription,
        "RETRACKOSDMESSAGE ORDER":
          "Order Re-Track OSD Message Added with commandName : " + obj.commandName,
        "APPLYPROMO ORDER": "Apply Promo Added for Order with Promo Id : " + obj.promoId,
        "TERMINATE ORDER":
          "Order Terminated successfully with OrderId : " + obj.resourceId,
        "DISCONNECT ORDER":
          "Order Disconnected Successfully with OrderId : " + obj.orderNo,
        "DISCONNECT MULTIPLEORDERS":
          "PlanCode : " +
          "(" +
          planDetails.planCode +
          ")" +
          "    " +
          "PlanDescription : " +
          "(" +
          planDetails.planDescription +
          ")",

        //payments related Data
        "CREATE PAYMENT":
          "Payment Done Successfully with Amount : " +
          obj.amountPaid +
          " , " +
          "Reciept No : " +
          obj.receiptNo,
        "CANCEL PAYMENT":
          "Payment Cancelled successfully with remarks " + obj.cancelRemark,

        //itemsale related data
        "CREATE ONETIMESALE":
          "Item Sale Created Successfully with Charge Code " +
          obj.chargeCode +
          " ,UnitPrice " +
          obj.unitPrice +
          "" +
          " ,Total Price " +
          obj.totalPrice +
          " ,Quantity " +
          obj.quantity +
          " and SaleType " +
          obj.saleType +
          "",

        "CREATE NEWSALE":
          "NEWSALE Created Successfully With Price : " +
          obj.totalPrice +
          " , " +
          "Quantity : " +
          obj.quantity +
          "," +
          "  SaleType : " +
          obj.saleType +
          " With Serial Number " +
          serialNumber,

        "DEALLOCATE INVENTORY": "Deallocated item",
        "DELETE ONETIMESALE": "Item sale deleted Successfully",
        "RENEWAL ORDER": "Order Renewaled Sucessfully with : " + obj.orderNo,

        "CREATE EVENTORDER":
          "Event Order Done Successfully Event Id" +
          obj.eventId +
          ", Format " +
          obj.formatType,

        //more info related data
        "CREATE PARENTCLIENT": "Parent Added to Client successfully",
        "CREATE CLIENTCARDDETAILS": "Client Credit Card Details Added successfully",

        //notes related data
        "CREATE CLIENTNOTE": "Client Notes Created Successfully",

        //statement related data
        "DELETE BILLMASTER": "Bill Statement Deleted successfully",

        //client identifier related data
        "CREATE CLIENTIDENTIFIER": "Client Identifier Added successfully",
        "DELETE CLIENTIDENTIFIER": "Client Identifier Deleted successfully",

        //ticket related data
        "CREATE TICKET": "Ticket Created Successfully",
        "CLOSE TICKET": "Ticket Closed Successfully",

        //client contact information related data
        "CREATE Client_Contact_Info": "Client Contact Information Added successfully",
        "UPDATE Client_Contact_Info": "Client Contact Information Updated successfully",
        "DELETE Client_Contact_Info": "Client Contact Information Deleted successfully",

        //credit distribution related data
        "CREATE CREDITDISTRIBUTION": "Credit Distribution ",

        //adjustment related data
        "CREATE ADJUSTMENT":
          "AmountPaid:" +
          obj.amount_paid +
          " AdjustmentType:" +
          obj.adjustment_type +
          " AdjustmentCode:" +
          obj.adjustment_code +
          " Remarks:" +
          obj.Remarks,

        "CREATE OWNEDHARDWARE": "Owned Hardware Created",
        "CREATE ALLOCATION": "Allocation Added successfully",

        //self care related data
        "SELFREGISTRATION ACTIVATE": "Selfcare Registration Activated",
        "CREATE SELFCARE":
          "Selfcare Account Created successfully with UserName:" + obj.userName,

        // Redemption related data
        "CREATE REDEMPTION": "Redemption done successfully PinNumber:" + obj.pinNumber,

        // ServiceTransfer related data
        "CREATE SERVICETRANSFER":
          "Service transfered from " +
          obj.oldPropertyCode +
          " to " +
          obj.newPropertyCode +
          " with Shift Charge Amount " +
          obj.shiftChargeAmount,

        //clientservice related data
        "CREATE CLIENTSERVICE":
          "Client Service Created Successfully For ServiceId : " + obj.serviceId + "",

        //clientsimpleactivation data
        "CREATE CLIENTSIMPLEACTIVATION":
          "Client Simple Activation Is Successful For ServiceId : " + serviceId + "",

        //provisioning details data
        "CONFIRM PROVISIONINGDETAILS": "Provisioning Details Confirmed",

        //client serviceactivation data
        "CREATE CLIENTSERVICEACTIVATION": "Client Service Activated Successfully",

        //clientservice terminate data
        "TERMINATE CLIENTSERVICE": "Client Service Terminated Successfully",

        //swaphardware device data
        "SWAP HARDWAREDEVICE":
          "Device Swapped Successfully From :" +
          obj.oldSerialNo +
          " To:" +
          obj.newSerialNo +
          "",

        //clientservice suspend data
        "SUSPEND CLIENTSERVICE": "Client Service Suspended Successfully ",

        //clientservice reactivate data
        "REACTIVE CLIENTSERVICE": "Client Service ReActivated Successfully ",

        //organization  data
        "CREATE OFFICE": "Create Office successfully with officeId:" + obj.resourceId,
        "UPDATE OFFICE": "Update Office successfully with officeId:" + obj.resourceId,
        "DELETE PARTNERAGREEMENT": "Delete partnerAgreement successfully",
        "CREATE PARTNERAGREEMENT": "Create partnerAgreement successfully",
        "CREATE OFFICEADJUSTMENT": "Create officeadjustment successfully",
        "CREATE OFFICEPAYMENT": "Create officepayment successfully",
      };
      return eventTypeCategoryMsg[activity.transactionType];
    },
    // 16-Recharge 32-CDR details 64-Notification
    async getRechargeData() {
      const payload = {
        mssisdn: this.clientDetailData.hwSerialNumber,
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment(this.recharge.toDate).format("YYYY-MM-DD"),
        dataId: 16,
        type: "recharge",
      };
      try {
        await this.$store.dispatch(
          "customerActivityLog/fetchRechargeCdrNotification",
          payload
        );
      } catch (error) {
        this.$swal({
          title: "No data",
          icon: "warning",
          text: "No data available",
          type: "warning",
        });
      }
    },
    async getCdrData() {
      const payload = {
        mssisdn: this.clientDetailData.hwSerialNumber,
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment(this.cdr.toDate).format("YYYY-MM-DD"),
        dataId: 32,
        type: "cdr",
      };
      try {
        await this.$store.dispatch(
          "customerActivityLog/fetchRechargeCdrNotification",
          payload
        );
      } catch (error) {
        this.$swal({
          title: "No data",
          icon: "warning",
          text: "No data available",
          type: "warning",
        });
      }
    },
    async getNotificationData() {
      const payload = {
        mssisdn: this.clientDetailData.hwSerialNumber,
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment(this.recharge.toDate).format("YYYY-MM-DD"),
        dataId: 64,
        type: "notification",
      };
      try {
        await this.$store.dispatch(
          "customerActivityLog/fetchRechargeCdrNotification",
          payload
        );
      } catch (error) {
        this.$swal({
          title: "No data",
          icon: "warning",
          text: "No data available",
          type: "warning",
        });
      }
    },
    async getSpendData() {
      const payload = {
        mssisdn: this.clientDetailData.hwSerialNumber,
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment(this.recharge.toDate).format("YYYY-MM-DD"),
        dataId: 131072,
        type: "spend",
      };
      try {
        await this.$store.dispatch(
          "customerActivityLog/fetchRechargeCdrNotification",
          payload
        );
      } catch (error) {
        this.$swal({
          title: "No data",
          icon: "warning",
          text: "No data available",
          type: "warning",
        });
      }
    },
    async getSlcData() {
      const payload = {
        mssisdn: this.clientDetailData.hwSerialNumber,
        fromDate: moment().startOf("year").format("YYYY-MM-DD"),
        toDate: moment(this.recharge.toDate).format("YYYY-MM-DD"),
        dataId: 128,
        type: "slc",
      };
      try {
        await this.$store.dispatch(
          "customerActivityLog/fetchRechargeCdrNotification",
          payload
        );
      } catch (error) {
        this.$swal({
          title: "No data",
          icon: "warning",
          text: "No data available",
          type: "warning",
        });
      }
    },
    // Message log
    stripTags(text) {
      return text.replace(/<([^>]+)>/g, "$1");
    },
    async getMessagesLogByCustomerMethod() {
      try {
        await this.$store.dispatch(
          "customerActivityLog/getMessagesLogByCustomerAction",
          this.clientId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    showMessage(data) {
      this.$swal({
        title: "Message",

        text: data.message,
        type: "info",
        customClass: {
          container: "message-container",
        },
      });
    },
    openPopup(data) {
      let obj = JSON.parse(data);
      this.parsedData = obj;
      this.messageLogPopup = true;
    },
  },
  watch: {
    activeTab(newVal) {
      if (newVal === 0) {
        this.getExternalTransactionHistoryList();
      }
      if (newVal === 1) {
        this.getRechargeData();
      }
      if (newVal === 2) {
        this.getCdrData();
      }
      if (newVal === 3) {
        this.getNotificationData();
      }
      if (newVal === 4) {
        this.getSlcData();
      }
      if (newVal === 5) {
        this.getSpendData();
      }
      if (newVal === 6) {
        this.getExternalTransactionHistoryList();
      }
      if (newVal === 7) {
        this.getMessagesLogByCustomerMethod();
      }
      if (newVal === 8) {
        this.getNotes();
      }
    },
  },
  async mounted() {
    this.getTransactionHistoryOfficeList();
  },
};
</script>
<style>
.vs-table--search {
  max-width: 100%;
}
.tab-heading {
  font-size: 1.3rem !important;
}
.date-field .vdp-datepicker {
  width: 150px !important;
  margin-top: 2px;
}
.end-date-calender .vdp-datepicker__calendar {
  right: 0;
}
.table-height .vs-table--content {
  min-height: 47vh;
}
.message-container .swal2-html-container {
  white-space: pre-line;
  word-wrap: break-word;
}
</style>
<style scoped>
  ::v-deep .vs-tabs--ul {
    width: 100%;
    display: flex;
    flex-wrap:wrap;
  }
  ::v-deep .line-vs-tabs{
    display: none !important;
  }
</style>
